module.exports = ".pass-icon{\r\n    color: #58db83;\r\n}\r\n\r\n.fail-icon{\r\n    color: #ec536c;\r\n}"